import { render, staticRenderFns } from "./JsObjectViewItem.vue?vue&type=template&id=60fafe97"
import script from "./JsObjectViewItem.vue?vue&type=script&lang=js"
export * from "./JsObjectViewItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports